<template>
  <div class="counselor-grid__cards grid" v-if="loading">
    <counselor-archive-card-skeleton
      v-for="index in numberOfCards"
      :key="index"
      :is-therapist="isTherapist"
    />
  </div>
</template>

<script>
import CounselorArchiveCardSkeleton from './CounselorArchiveCardSkeleton.vue';

export default {

  components: {
    CounselorArchiveCardSkeleton,
  },
  name: 'CounselorGridLoader',

  props: {

    isTherapist: {
      required: true,
      type: Boolean,
    },
    loading: {
      required: true,
      type: Boolean,
    },

    numberOfCards: {
      default: 6,
      required: false,
      type: Number,
    },
  },
};
</script>
